var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "10.462px",
    height: "7.816px",
    viewBox: "0.65 0.397 10.462 7.816",
    enableBackground: "new 0.65 0.397 10.462 7.816",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.091,4.355L7.256,8.191C7.242,8.205,7.223,8.213,7.203,8.213S7.165,8.205,7.151,8.19L6.317,7.354 C6.315,7.352,6.313,7.35,6.311,7.348C6.287,7.316,6.291,7.272,6.32,7.246C6.321,7.244,6.323,7.23,6.326,7.229L8.541,5H0.724 C0.683,5,0.5,4.993,0.5,4.952V3.655C0.5,3.614,0.683,4,0.724,4h7.817L6.316,1.567C6.303,1.553,6.295,1.43,6.295,1.41 s0.008-0.091,0.021-0.104l0.835-0.861C7.166,0.43,7.185,0.41,7.203,0.41c0.02,0,0.038,0,0.053,0.015l3.835,3.83 c0.015,0.014,0.021,0.031,0.021,0.05S11.104,4.341,11.091,4.355z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.ebc9c0f7.svg";
export { ForwardRef as ReactComponent };